import {
    HttpResponse,
    ScrapReasonModel,
    RequestParams,
    ApiResultFailed,
    Operation,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery, CrudService} from '@/libs/core/+state/models/crud-service';
import {CrudEnumerableResponse, CrudResponse} from "../core/+state/models/crud-response";

export class ScrapReasonsDataService implements CrudService<ScrapReasonModel, ScrapReasonModel> {
    getAll(query: CrudDataQuery<ScrapReasonModel>): Promise<CrudEnumerableResponse<ScrapReasonModel>> {
        return ApiService.api.getScrapReasonBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    getBasicAll(query: CrudDataQuery<ScrapReasonModel>): Promise<CrudEnumerableResponse<ScrapReasonModel>> {
        throw new Error('NotImplemented');
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<ScrapReasonModel>> {
        return ApiService.api.getScrapReasonById(id, params);
    }

    create(item: ScrapReasonModel, params?: RequestParams): Promise<CrudResponse<ScrapReasonModel>> {
        return ApiService.api.insertScrapReason(item, params);
    }

    update(item: ScrapReasonModel, params?: RequestParams): Promise<ScrapReasonModel> {
        return ApiService.api.updateScrapReason(item.id as Required<string>, item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<ScrapReasonModel> {
        return ApiService.api.patchScrapReason(id, patches, params).then((req: any) => req.data.returnValue);
    }

    delete(query: CrudDataQuery<ScrapReasonModel>): Promise<CrudEnumerableResponse<ScrapReasonModel>> {
        return ApiService.api.deleteScrapReasons(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        return ApiService.api.aggregationScrapReason(query, params).then((req: any) => req.data.returnValue);
    }

    download(query: CrudDataQuery<ScrapReasonModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw new Error('NotImplemented');
    }

    clone(item: ScrapReasonModel, params?: RequestParams): Promise<CrudResponse<ScrapReasonModel>> {
        throw new Error('NotImplemented');
    }

    getGroupped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        return ApiService.api.getScrapReasonGroupped(query, params);
    }

}
